<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <router-view></router-view>
</template>

<script>
export default {
  name: "LayoutScannerDefault",
};
</script>
